import { useRef, useState } from 'react'
import { Info } from 'lucide-react'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { FELDHILFE } from '@/pages/grundartikel/feldhilfe'

export function FeldHilfe({ feld }: { feld: keyof typeof FELDHILFE }) {
  const [open, setOpen] = useState(false)
  const focused = useRef(false)
  const hilfe = FELDHILFE[feld]
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" aria-label={`Hilfe: ${hilfe.titel}`}
          className="inline-flex size-7 shrink-0 items-center justify-center rounded text-ink-2 hover:text-primary focus-visible:outline-2 focus-visible:outline-primary"
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={() => { if (!focused.current) setOpen(false) }}
          onFocus={() => { focused.current = true; setOpen(true) }}
          onBlur={() => { focused.current = false; setOpen(false) }}
          // Fokus öffnet schon vor dem Klick. Der Klick soll das Popover offen halten.
          onClick={event => { event.preventDefault(); setOpen(true) }}>
          <Info className="size-3.5" aria-hidden />
        </button>
      </PopoverTrigger>
      <PopoverContent className="max-w-[calc(100vw-2rem)] border-line-2 bg-panel text-ink"
        onOpenAutoFocus={event => event.preventDefault()}
        onCloseAutoFocus={event => event.preventDefault()}>
        <p className="font-display font-semibold text-sm">{hilfe.titel}</p>
        <p className="mt-1 text-xs leading-relaxed text-ink-2">{hilfe.text}</p>
      </PopoverContent>
    </Popover>
  )
}
